import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Box, Button, CircularProgress, Grid, IconButton, } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { useTranslation } from "react-i18next";
import DataTable from "../../components/common/DataTable";
import CustomModal from "../../components/common/CustomModal";
import { ENQUIRY_COMPANY_SEARCH, ENQUIRY_LEAD_CONVERT_TO_USER_ONBOARDING, ENQUIRY_LEAD_DELETE, ENQUIRY_LEAD_LIST, } from "../../services/apiRoutes"
import { getIndustryType, getRating, getLeadSource, getLeadStatus, getCountries, getBusinessGroup, formatDate, getOwner, getTitles, getBusinessProfile, } from '../../services/CommonServices'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import axios from 'axios';
import CustomLoader from "../../components/common/CustomLoader";
import MessageBox from "../../components/common/CustomMessageBox";
import CustomDelete from '../../components/common/CustomDeleteAlert'
import { AuthContext } from "../../context/AuthContext";
import CustomFilter from "../../components/common/CustomFilter";
import CustomTextField from "../../components/common/CustomTextField";
import CustomAutocomplete from "../../components/common/CustomAutoComplete";
import { ClearRounded } from "@mui/icons-material";
import CustomButton from "../../components/common/CustomButton";
import FindReplaceOutlinedIcon from '@mui/icons-material/FindReplaceOutlined';
import { hasEditPermission, hasDeletePermission } from '../../services/CommonServices'
import { useLocation } from "react-router-dom";
import CustomStatus from "../../components/common/CustomStatus";
import CreateEnquiryLeads from "../components/CreateForm/CreateEnquiryLeads";
import UpdateEnquiryLeads from "../components/UpdateForm/UpdateEnquiryLeads";
import { genericPost } from "../../services/authServices";
import CustomDataTable from "../../components/common/CustomDataTable";
import debounce from "lodash/debounce";

const title = "Leads Management";

const EnquiryLeads = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { token } = useContext(AuthContext)
    const [leadModal, setLeadModal] = useState(false);
    const [updateLeadModal, setUpdateLeadModal] = useState(false);
    const [error, setError] = useState(null);
    const [getAllLead, setGetAllLead] = useState([]);
    const [industryType, setIndustryType] = useState([]);
    const [rating, setRating] = useState([]);
    const [leadSource, setLeadSource] = useState([]);
    const [leadStatus, setLeadStatus] = useState([]);
    const [conutries, setConutries] = useState([]);
    const [businessGroup, setBusinessGroup] = useState([]);
    const [leadOwner, setLeadOwner] = useState([]);
    const [titles, setTitles] = useState([]);
    const [loading, setLoading] = useState(false)
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [rowId, setRowId] = useState('')
    const [openDrawer, setOpenDrawer] = useState(false);
    const [permission, setPermissions] = useState()
    const [searchCompany, setSearchCompany] = useState([]);
    const [page, setPage] = useState(0); // UI 0-based
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);
    const [convertLoadingId, setConvertLoadingId] = useState(null);

    const [filterPayload, setFilterPayload] = useState({
        clientCompanyId: '',
        leadSourceId: '',
        leadStatusId: '',
        industry: '',
        businessGroup: '',
        countryId: '',
        fromDate: '',
        toDate: '',
    });
    const businessProfile = getBusinessProfile();
    const basePath =
        businessProfile === "partner"
            ? "/partner"
            : "/alexxcansols";

    const currentDate = new Date();
    const sevenDaysAgo = new Date(currentDate);
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 5);
    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    })

    const filterOpen = () => setOpenDrawer(true);
    const filterClose = () => setOpenDrawer(false);

    const columns = useMemo(
        () => [
            {
                accessorKey: "index", header: "SN.", size: 50, tableHeader: { alignItems: 'center', }, tableStyle: { textAlign: "center" },
                enableSorting: true,
                enableColumnFilter: true
            },
            { accessorKey: "createdAt", header: "Date", size: 100, tableStyle: { textAlign: "center" }, enableSorting: false, },
            {
                accessorKey: "company", header: "Company", size: 150, enableSorting: false, tableHeader: {
                    justifyContent: 'flex-start',
                },
            },
            {
                accessorKey: "country", header: "Country", size: 50, enableSorting: false, tableHeader: {
                    justifyContent: 'flex-start',
                },
            },
            {
                accessorKey: "contactPerson", header: "Contact Person", size: 50, enableSorting: false, tableHeader: {
                    justifyContent: 'flex-start',
                },
            },
            {
                accessorKey: "email", header: "Email Id", size: 50, enableSorting: false, tableHeader: {
                    justifyContent: 'flex-start',
                },
            },
            { accessorKey: "contactNo", header: "Contact No.", size: 50, tableStyle: { textAlign: "center" }, enableSorting: false },
            {
                accessorKey: "leadStatus",
                header: "Lead Status",
                tableStyle: { textAlign: "center" },
                size: 50,
                Cell: ({ row }) => {
                    return (
                        <CustomStatus
                            title={row.original.leadStatus}
                            sx={{
                                backgroundColor: row.original.leadStatusBackground,
                                color: row.original.leadStatusColor,
                                border: `1px solid ${row.original.leadStatusColor}`,
                                textAlign: "center",
                                display: "inline-block",
                            }}
                        />
                    );
                },
                enableSorting: false,
            },

            {
                accessorKey: "source",
                header: "Source",
                tableStyle: { textAlign: "center" },
                size: 50,
                Cell: ({ row }) => {
                    return (
                        <CustomStatus
                            title={row.original.source}
                            sx={{
                                backgroundColor: row.original.leadsourceBackground,
                                color: row.original.leadsourceColor,
                                border: `1px solid ${row.original.leadsourceColor}`,
                                textAlign: "center",
                                display: "inline-block",
                            }}
                        />
                    );
                },
                enableSorting: false,
            },
            {
                accessorKey: "expectedPurchaseDate",
                header: "Purchase Date",
                size: 50,
                tableStyle: { textAlign: "center", },
                enableSorting: false
            },
            {
                accessorKey: "action",
                header: "User Onboarding",
                size: 50,
                enableSorting: false,
                Cell: ({ row }) => (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                            <Button
                                variant="outlined"
                                onClick={() => handleConvertLead(row.original.leadId)}
                                disabled={convertLoadingId === row.original.leadId}
                                sx={{
                                    color: '#007BFF',
                                    borderColor: '#007BFF',
                                    display: 'inline-flex',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    whiteSpace: 'nowrap',
                                    borderRadius: '4px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    textTransform: "capitalize",
                                    height: "25px",
                                    padding: "2px 6px 2px 6px",
                                    width: 'fit-content',

                                }}
                            >
                                {convertLoadingId === row.original.leadId ? (
                                    <CircularProgress size={18} sx={{ color: "#007BFF" }} />
                                ) : (
                                    "User Onboarding"
                                )}
                            </Button>
                        </div>
                    </>
                ),
            },
            {
                accessorKey: "action",
                header: "Action",
                size: 100,
                Cell: ({ row }) => (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                            <IconButton onClick={() => handleViewClick(row.original.leadId)}>
                                <VisibilityIcon style={{ color: "#059212" }} />
                            </IconButton>
                            {permission?.edit &&
                                <IconButton onClick={() => handleUpdateClick(row.original.leadId)}>
                                    <ModeEditOutlineOutlinedIcon style={{ color: "#050C9C" }} />
                                </IconButton>
                            }

                            {permission?.delete && <IconButton onClick={() => handleOpenDeleteAlert(row.original.leadId)}>
                                <DeleteOutlineOutlinedIcon style={{ color: "#E4003A" }} />
                            </IconButton>}
                        </div>
                    </>

                ),
                enableSorting: false
            },

        ],
        [permission]
    );

    const [selectedLeadId, setSelectedLeadId] = useState(null);

    const handleUpdateClick = (leadId) => {
        setSelectedLeadId(leadId);
        setUpdateLeadModal(true);
    };


    const handleCloseUpdateLead = () => {
        setUpdateLeadModal(false);
    };
    const location = useLocation();
    const currentPath = location.pathname;

    // useEffect(() => {
    //     let rolePermisionsData = JSON.parse(sessionStorage.getItem('userData')) || []
    //     let editPermision = hasEditPermission(currentPath, rolePermisionsData?.permissions)
    //     let deletePermission = hasDeletePermission(currentPath, rolePermisionsData?.permissions)
    //     setPermissions({
    //         edit: editPermision,
    //         delete: deletePermission
    //     })
    // }, [])

    useEffect(() => {
        let rolePermisionsData = JSON.parse(sessionStorage.getItem('userData')) || [];

        // ❗ Map current path "/alexxcansols/leads" to permission path "/app/leads"
        // let mappedPath = currentPath.replace("/alexxcansols", "/app");
        const mappedPath = currentPath.replace(
            /^\/(alexxcansols|app|partner)/,
            "/app"
        );
        let editPermision = hasEditPermission(mappedPath, rolePermisionsData?.permissions);
        let deletePermission = hasDeletePermission(mappedPath, rolePermisionsData?.permissions);

        setPermissions({
            edit: editPermision,
            delete: deletePermission
        });
    }, [currentPath]);


    const handleDelete = async (leadId) => {
        setLoading(true)
        const authToken = sessionStorage.getItem('accessToken');
        try {
            const response = await axios.delete(ENQUIRY_LEAD_DELETE(leadId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200) {
                getLeadList()
                setDeleteAlert(false)
                setMessage({
                    open: true,
                    text: response?.data?.message || "Delete successfully",
                    type: "success",
                });
            } else {
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            console.error("Error deleting lead", error);
        }
    };

    const handleFilterChange = (field, value) => {
        setFilterPayload((prev) => ({
            ...prev,
            [field]: value || '',
        }));
    };


    const handleClearFilters = useMemo(() => {
        return () => {
            setFilterPayload({
                clientCompanyId: '',
                leadSourceId: '',
                leadStatusId: '',
                industry: '',
                businessGroup: '',
                countryId: '',
                fromDate: '',
                toDate: '',
            });
            getLeadList(0, pageSize, '');
        };
    }, [pageSize]);

    const getLeadList = async (pageIndex = 0, pageSize = 10) => {
        setLoading(true);
        try {
            const payload = {
                page: pageIndex + 1,
                limit: pageSize,
                ...filterPayload
            };
            const response = await genericPost(ENQUIRY_LEAD_LIST, payload, {});
            if (response.data) {
                const LeadData = response.data.leads.map((lead, index) => ({
                    ...lead,
                    leadId: lead.leadId || '',
                    index: (index + 1).toString().padStart(2, '0'),
                    createdAt: formatDate(lead.createdAt),
                    expectedDate: lead.expectedDate || '',
                    email: lead.email || '',
                    company: lead.clientCompany?.companyName || '',
                    country: lead.country?.name || lead.name || '',
                    contactPerson: `${lead.firstName || ''} ${lead.lastName || ''}`,
                    contactNo: lead.mobile || lead.phone || '',
                    leadStatus: lead.leadStatus?.leadStatusName || lead.leadStatusName || '',
                    source: lead.leadSource?.leadSourceName || lead.leadSourceName || '',
                    expectedPurchaseDate: lead.expectedDate || '',
                    rating: lead.ratings?.ratingName || '',
                    ratingColor: lead.ratings?.ColorPlate?.color || '#000000',
                    ratingBackground: lead.ratings?.ColorPlate?.backgroundColor || '#ffffff',
                    leadStatusColor: lead.leadStatus?.ColorPlate?.color || '#000000',
                    leadStatusBackground: lead.leadStatus?.ColorPlate?.backgroundColor || '#ffffff',
                    leadsourceColor: lead.leadSource?.ColorPlate?.color || '#000000',
                    leadsourceBackground: lead.leadSource?.ColorPlate?.backgroundColor || '#ffffff',


                }));
                setGetAllLead(LeadData);
                setRowCount(response.data.pagination?.totalRecords || 0);
                setLoading(false)
            } else {
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            console.error("Error fetching leads", error);
        }
    };


    const handleConvertLead = async (leadId) => {
        setConvertLoadingId(leadId);

        try {
            const accessToken = sessionStorage.getItem("accessToken");

            const response = await axios.post(
                ENQUIRY_LEAD_CONVERT_TO_USER_ONBOARDING(leadId), // ✅ leadId in URL
                {}, // ✅ no payload needed (unless backend expects it)
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            if (response.status === 200 || response.status === 201) {
                setMessage({
                    open: true,
                    text: response.data?.message || "Lead converted to onboarding user successfully",
                    type: "success",
                });
            }
        } catch (error) {
            console.error("Convert lead error:", error);
            setMessage({
                open: true,
                text: error.response?.data?.message || "Something went wrong",
                type: "error",
            });
        } finally {
            setConvertLoadingId(null);
        }
    };



    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }

    useEffect(() => {
        getLeadList(page, pageSize,)
    }, [page, pageSize, token,])


    useEffect(() => {
        getCommonData()
    }, [])

    const getCommonData = async () => {
        const industryTypeData = await getIndustryType()
        setIndustryType(industryTypeData);
        const ratingData = await getRating()
        setRating(ratingData);
        const leadSourceData = await getLeadSource()
        setLeadSource(leadSourceData)
        const leadStatusData = await getLeadStatus()
        setLeadStatus(leadStatusData)
        const getConutriesData = await getCountries()
        setConutries(getConutriesData)
        const businessGroupData = await getBusinessGroup()
        setBusinessGroup(businessGroupData)
        const leadOwner = await getOwner()
        setLeadOwner(leadOwner)
        const titlesData = await getTitles()
        setTitles(titlesData)
    }

    const handleOpen = () => {
        setLeadModal(true);
    };
    const handleClose = () => {
        setLeadModal(false)
    }
    const handleViewClick = (leadId) => {
        navigate(`${basePath}/leads/${leadId}`);
    };

    const fetchClientCompanies = async (query) => {
        setLoading(true);
        try {
            const url = `${ENQUIRY_COMPANY_SEARCH}?companyName=${encodeURIComponent(query || "")}`;
            const response = await genericPost(url);

            if (response.data.success && response.data.clientCompanies) {
                const options = response.data.clientCompanies.map(c => ({
                    id: c.clientCompanyId,
                    title: c.companyName
                }));
                setSearchCompany(options);
            } else {
                setSearchCompany([]);
                setError("No client companies found");
            }
        } catch (err) {
            setSearchCompany([]);
            setError("Error fetching client companies");
        } finally {
            setLoading(false);
        }
    };

    const debouncedFetch = useMemo(() => debounce(fetchClientCompanies, 500), []);
    useEffect(() => {
        fetchClientCompanies("");
        return () => debouncedFetch.cancel();
    }, []);


    return (
        <>
            <Box sx={{ padding: "10px" }}>
                <CustomLoader open={loading} />
                <CustomDataTable
                    title={title}
                    columns={columns}
                    data={getAllLead}
                    buttonTitle="Create"
                    handleOpen={handleOpen}
                    handleFilterButton={filterOpen}
                    fiterButtonTitile="Fiter"
                    rowCount={rowCount}
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    fromDate={filterPayload.fromDate || ""}
                    toDate={filterPayload.toDate || ""}
                />
                <CustomModal open={leadModal}  >
                    <CreateEnquiryLeads
                        handleClose={handleClose}
                        industryType={industryType}
                        clientCompany={searchCompany}
                        leadOwner={leadOwner}
                        rating={rating}
                        leadSource={leadSource}
                        titles={titles}
                        leadStatus={leadStatus}
                        conutries={conutries}
                        businessGroup={businessGroup}
                        getLeadList={getLeadList}
                        setMessage={setMessage}
                        debouncedFetch={debouncedFetch}
                        loading={loading}
                    />
                </CustomModal>

                <CustomModal open={updateLeadModal}  >
                    <UpdateEnquiryLeads
                        handleClose={handleCloseUpdateLead}
                        industryType={industryType}
                        titles={titles}
                        rating={rating}
                        clientCompany={searchCompany}
                        leadSource={leadSource}
                        leadStatus={leadStatus}
                        leadOwner={leadOwner}
                        getAllLead={getAllLead.find((v) => v.leadId == selectedLeadId)}
                        conutries={conutries}
                        getLeadList={getLeadList}
                        setMessage={setMessage}
                        leadId={selectedLeadId}
                        businessGroup={businessGroup}
                        debouncedFetch={debouncedFetch}
                        loadingCompany={loading}
                    />
                </CustomModal>
                <MessageBox
                    open={message.open}
                    onClose={() => setMessage({ ...message, open: false })}
                    message={message.text}
                    handleClose={() => setMessage({ ...message, open: false })}
                    type={message.type}
                />
                <CustomDelete
                    handleDelete={handleDelete}
                    open={deleteAlert}
                    rowId={rowId}
                    handleClose={() => setDeleteAlert(false)}
                />
                <CustomFilter
                    drawerTitle="Filter Options"
                    drawerWidth={300}
                    openDrawer={openDrawer}
                    onClose={filterClose}
                    drawerContent={
                        <>
                            <Box>
                                <Grid container spacing={1} sx={{ padding: 0, }}>
                                    <Grid item xs={12}>
                                        <CustomAutocomplete
                                            options={searchCompany}
                                            getOptionLabel={(o) => o.title}
                                            placeholder="Select Company"
                                            value={searchCompany.find(i => i.id === filterPayload.clientCompanyId) || null}
                                            onInputChange={(e, v, r) => r === "input" && debouncedFetch(v)}
                                            onChange={(e, v) => handleFilterChange("clientCompanyId", v?.id)}
                                            loading={loading}
                                        />
                                    </Grid>
                                    <Grid item xs={8} sm={12} md={12}>

                                        <CustomAutocomplete
                                            options={conutries}
                                            getOptionLabel={(option) => option.title}
                                            placeholder="Select Country"
                                            onChange={(event, newValue) => handleFilterChange("countryId", newValue?.id)}
                                            value={conutries.find((item) => item.id === filterPayload.countryId) || null}
                                        />
                                    </Grid>
                                    <Grid item xs={8} sm={12} md={12}>

                                        <CustomAutocomplete
                                            options={leadStatus}
                                            getOptionLabel={(option) => option.title}
                                            placeholder="Select Lead Status"
                                            onChange={(event, newValue) => handleFilterChange("leadStatusId", newValue?.id)}
                                            value={leadStatus.find((item) => item.id === filterPayload.leadStatusId) || null}

                                        />
                                    </Grid>
                                    <Grid item xs={8} sm={12} md={12}>

                                        <CustomAutocomplete
                                            options={leadSource}
                                            getOptionLabel={(option) => option.title}
                                            placeholder="Select Lead Source"
                                            onChange={(event, newValue) => handleFilterChange("leadSourceId", newValue?.id)}
                                            value={leadSource.find((item) => item.id === filterPayload.leadSourceId) || null}
                                        />
                                    </Grid>
                                    <Grid item xs={8} sm={12} md={12}>

                                        <CustomAutocomplete
                                            options={industryType}
                                            getOptionLabel={(option) => option.title}
                                            placeholder="Select Industry"
                                            onChange={(event, newValue) => handleFilterChange("industry", newValue?.id)}
                                            value={industryType.find((item) => item.id === filterPayload.industry) || null}
                                        />
                                    </Grid>
                                    <Grid item xs={8} sm={12} md={12}>

                                        <CustomAutocomplete
                                            options={businessGroup}
                                            getOptionLabel={(option) => option.title}
                                            placeholder="Business Group"
                                            onChange={(event, newValue) => handleFilterChange("businessGroup", newValue?.id)}
                                            value={businessGroup.find((item) => item.id === filterPayload.businessGroup) || null}
                                        />
                                    </Grid>
                                    <Grid item xs={8} sm={12} md={12}>
                                        <CustomTextField
                                            fieldLabel="From Date"
                                            type="date"
                                            value={filterPayload.fromDate}
                                            onChange={(e) => handleFilterChange('fromDate', e.target.value)}
                                            placeholder="From Date"
                                        />
                                    </Grid>
                                    <Grid item xs={8} sm={12} md={12}>
                                        <CustomTextField
                                            fieldLabel="To Date"
                                            type="date"
                                            value={filterPayload.toDate}
                                            onChange={(e) => handleFilterChange('toDate', e.target.value)}
                                            placeholder="To Date"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} sx={{ display: 'flex', alignItems: 'center', marginTop: "10px" }}>
                                        <CustomButton
                                            startIcon={<FindReplaceOutlinedIcon />}
                                            title="Apply"
                                            size="small"
                                            variant="contained"
                                            onClick={getLeadList}
                                        />
                                        <CustomButton
                                            variant="outlined"
                                            title="Clear"
                                            startIcon={<ClearRounded />}
                                            style={cif_fob_style}
                                            onClick={handleClearFilters}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </>
                    }
                />

            </Box>
        </>
    );
};
export default EnquiryLeads;

const cif_fob_style = {
    backgroundColor: '#ffff',
    color: '#007bff',
    textTransform: "capitalize",
    borderRadius: 4,
    border: '1px solid #007bff',
    height: 30,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: "100px"

}
